module.exports = __webpack_public_path__ + "static/media/insect(39).4830d9ae.PNG";